module.exports = __webpack_public_path__ + "static/w-citrix-918c54deb9301cfc2e93ab2b712cedbb.webp";